module.exports = __webpack_public_path__ + "media/pt_pt_s1_Beatriz.d78ccabb.mp3";